// extracted by mini-css-extract-plugin
export default {"wrapper":"aTJnnjuKYNuoa01tiggYmg==","video":"IYDmxSIyz30onVu6kuvLew==","fallback":"igW5o3rO072qaD2iRtZdYg==","overlay":"tN1QvWn8BTEsFlpsICtVSw=="};